import { mdiCircleMedium } from '@mdi/js'

const themeConfig = {
  app: {
    name: ' نواندیشان آلومینیوم خراسان',
    logo: require('@/assets/images/logo.png'),
    isDark: false,
    isRtl: true,
    contentLayoutNav: 'vertical', // vertical, horizontal
    routeTransition: 'scroll-x-transition', // https://vuetifyjs.com/en/styles/transitions/#api
    skinVariant: 'bordered', // default, bordered, semi-dark
    contentWidth: 'full-width', // full-width, boxed
  },
  menu: {
    isMenuHidden: false,
    isVerticalNavMini: false,
    verticalMenuAccordion: false,
    groupChildIcon: mdiCircleMedium,
    horizontalNavMenuGroupOpenOnHover: true,
  },
  appBar: {
    type: 'fixed', // fixed, static, hidden
    isBlurred: true,
  },
  footer: {
    type: 'static', // fixed, static, hidden
  },
  themes: {
    light: {
      primary: '#2c2e8b',
      accent: '#0d6efd',
      secondary: '#8A8D93',
      success: '#42a00a',
      info: '#16B1FF',
      warning: '#FFB400',
      error: '#FF4C51',
    },
  },
}

export default themeConfig
